module.exports = __webpack_public_path__ + "img/bj.7b03c00e.svg";